<template>
  <div class="log-page">
    <!-- 顶部导航 -->
    <header class="header">
      <div class="header-back" @click="back()">
        <van-icon name="arrow-left" />
      </div>
      <h1 class="header-title">{{ $t('my.bill_record') || '賬變記錄' }}</h1>
      <div class="header-placeholder"></div>
    </header>

    <!-- Tab切換 -->
    <div class="tab-bar">
      <div class="tab-item" :class="{ active: activeTab === 'all' }" @click="switchTab('all')">
        {{ $t('log.all') || '全部' }}
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'income' }" @click="switchTab('income')">
        {{ $t('log.income') || '收入' }}
      </div>
      <div class="tab-item" :class="{ active: activeTab === 'expense' }" @click="switchTab('expense')">
        {{ $t('log.expense') || '支出' }}
      </div>
    </div>

    <!-- 列表內容 -->
    <div class="list-container">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="filteredList.length === 0" :description="$t('withdraw.empty_data') || '數據為空'" />
        <div v-else class="log-list">
          <div class="log-item" v-for="(item, index) in filteredList" :key="index">
            <div class="log-left">
              <span class="log-type">{{ item.type == 3 ? '收入 - ' : '支出 - ' }}{{ item.text || '' }}</span>
              <span class="log-desc">{{ item.memo || '' }}</span>
            </div>
            <div class="log-right">
              <span class="log-amount" :class="item.type == 3 ? 'income' : 'expense'">
                {{ item.type == 3 ? '+' : '-' }}{{ item.num || '0.00' }} HKD
              </span>
            </div>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: 'all',
      isLoading: false,
      list: []
    };
  },
  computed: {
    filteredList() {
      if (this.activeTab === 'all') {
        return this.list;
      } else if (this.activeTab === 'income') {
        return this.list.filter(item => item.type == 3);
      } else {
        return this.list.filter(item => item.type != 3);
      }
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    switchTab(tab) {
      this.activeTab = tab;
      this.list = [];
      this.getUserGameList();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('reservation.refresh') || '刷新成功');
        this.isLoading = false;
      }, 500);
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        data: {
          tab: this.activeTab
        },
        url: 'user_get_log_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data || [];
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserGameList();
    }
  }
};
</script>

<style lang="less" scoped>
.log-page {
  min-height: 100vh;
  background: #000;
  color: #f5f5f5;
}

/* 头部 */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #000;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header-back {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 28px;
  color: #fff;
}

.header-title {
  flex: 1;
  text-align: center;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
  color: #22cc61;
}

.header-placeholder {
  width: 40px;
}

/* Tab切換 */
.tab-bar {
  display: flex;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.tab-item {
	width:33.33%;
  padding: 16px 20px;
  font-size: 28px;
  color: #999;
  cursor: pointer;
  position: relative;
  text-align: center;
}

.tab-item.active {
  color: #22cc61;
}

.tab-item.active::after {
  content: "";
  position: absolute;
  left: 80px;
  right: 80px;
  bottom: 0;
  height: 3px;
  background: #22cc61;
  border-radius: 2px;
}

/* 列表容器 */
.list-container {
  padding: 0 16px;
}

/* 列表項 */
.log-list {
  padding-top: 8px;
}

.log-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}


.log-left {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  overflow: hidden;
}

.log-type {
  font-size: 28px;
  color: #fff;
  font-weight: 500;
}

.log-desc {
  font-size: 24px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.log-right {
  flex-shrink: 0;
  margin-left: 16px;
}

.log-amount {
  font-size: 28px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.log-amount.income {
  color: #22cc61;
}

.log-amount.expense {
  color: #ff4500;
}
</style>
